import { ClinicalWizard } from '../clinical/ClinicalWizard';
import { SDI_WIZARD_CONFIG } from './sdiWizardConfig';
import type { ActionRunnerProps, TimelineEvent } from '../types';

interface SdiWizardProps extends ActionRunnerProps {
    editingEvent?: TimelineEvent;
    resumingDraft?: TimelineEvent;
    onSubmitted?: () => void;
    inWorkflow?: boolean;
}

function SdiWizard(props: SdiWizardProps) {
    return <ClinicalWizard {...props} config={SDI_WIZARD_CONFIG} />;
}

export { SdiWizard };
export type { SdiWizardProps };
